import { generateRequest } from '.';

export const Action = {
  Spotters: {
    SpottersPending: 'Spotters_PENDING',
    SpottersCompleted: 'Spotters_FULFILLED',
    SpottersFailed: 'Spotters_FAILED',
  },
};

export const fetchTopSpotters = stationId => generateRequest({
  endpoint: `/assets-v2/api/stations/${stationId}/spotters`,
  types: [
    Action.Spotters.SpottersPending,
    Action.Spotters.SpottersCompleted,
    Action.Spotters.SpottersFailed,
  ],
});
